import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		root: {
			padding: '2px 0px',
			display: 'flex',
			alignItems: 'flex-start',
			alignSelf: 'stretch',
			borderRadius: 10,
			flexDirection: 'column',
			zIndex: 101,
			'& > div:first-child': {
				display: 'flex',
				// flexGrow: 1,
				alignSelf: 'stretch',
			},
			'& > div:not(:first-child)': {
				overflow: 'auto',
				flex: 1,
			},
		},
		chip: {
			margin: 2,
			'&:hover, &:focus': {
				backgroundColor: '#e1e1f4 !important',
				color: '#1B1A7C',
			}
		},
		availableLocations: {
			alignSelf: 'stretch',
			background: '#fff',
			borderRadius: '0 0 10px 10px'
		},
		availableLocationsContainer: {
			padding: '10px'
		},
		input: {
			color: '#000000',
			fontSize: '14px',
			padding:0
		},
	})
